import { all, takeEvery, put, fork, call } from 'redux-saga/effects';
import {
	AUTH_TOKEN,
	SIGNIN,
	SIGNOUT,
	SIGNUP,
	SIGNIN_WITH_GOOGLE,
	SIGNIN_WITH_FACEBOOK,
	GET_USER_DATA,
	REGISTER_TOKEN,
	CAPTCHA_TOKEN
} from '../constants/Auth';
import {
	showAuthMessage,
	authenticated,
	signOutSuccess,
	signUpSuccess,
	signInWithGoogleAuthenticated,
	signInWithFacebookAuthenticated
} from "../actions/Auth";

import FirebaseService from 'services/FirebaseService'

export function* signInWithFBEmail() {
  yield takeEvery(SIGNIN, function* ({payload}) {
		try {
			// const user = yield call(FirebaseService.signInEmailRequest, email, password);
			// if (user.message) {
			// 	yield put(showAuthMessage(user.message));
			// } else {
			if(payload) {
				localStorage.setItem(AUTH_TOKEN, payload);
				yield put(authenticated(payload));
			}
		} catch (err) {
			yield put(showAuthMessage(err));
		}
	});
}

export function* signOut() {
	yield takeEvery(SIGNOUT, function* () {
	  try {
		console.log("🚀 Signing out...");
  
		// ✅ Call Firebase sign-out request (optional)
		const signOutUser = yield call(FirebaseService.signOutRequest);
  
		// ✅ Always remove stored tokens (even if Firebase request fails)
		localStorage.removeItem("token"); // ✅ Ensures token is removed
		localStorage.removeItem(REGISTER_TOKEN);
		localStorage.removeItem(CAPTCHA_TOKEN);
  
		// ✅ Dispatch Redux sign-out success
		yield put(signOutSuccess());
  
		console.log("✅ Logout successful, reloading...");
		window.location.href = "/en/login"; // ✅ Redirect to login page
  
	  } catch (err) {
		console.error("❌ Logout Error:", err);
		yield put(showAuthMessage("Failed to log out. Please try again."));
	  }
	});
  }
  

export function* signUpWithFBEmail() {
  yield takeEvery(SIGNUP, function* ({payload}) {
		const {email, password} = payload;
		try {
			const user = yield call(FirebaseService.signUpEmailRequest, email, password);
			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				/*localStorage.setItem(AUTH_TOKEN, user.user.uid);*/
				yield put(signUpSuccess(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error));
		}
	}
	);
}

export function* signInWithFBGoogle() {
  yield takeEvery(SIGNIN_WITH_GOOGLE, function* () {
		try {
			const user = yield call(FirebaseService.signInGoogleRequest);
			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				/*localStorage.setItem(AUTH_TOKEN, user.user.uid);*/
				yield put(signInWithGoogleAuthenticated(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error));
		}
	});
}

export function* signInWithFacebook() {
  yield takeEvery(SIGNIN_WITH_FACEBOOK, function* () {
		try {
			const user = yield call(FirebaseService.signInFacebookRequest);
			if (user.message) {
				yield put(showAuthMessage(user.message));
			} else {
				/*localStorage.setItem(AUTH_TOKEN, user.user.uid);*/
				yield put(signInWithFacebookAuthenticated(user.user.uid));
			}
		} catch (error) {
			yield put(showAuthMessage(error));
		}
	});
}

export default function* rootSaga() {
  yield all([
		fork(signInWithFBEmail),
		fork(signOut),
		fork(signUpWithFBEmail),
		fork(signInWithFBGoogle),
		fork(signInWithFacebook)
  ]);
}
